import Alpine from 'alpinejs';
import { AgeVerification } from './age_verification';
import { getCookie } from '@/utils/cookie';
import { VideoEdition } from './types';

const coc = getCookie('coc').toLowerCase();
Alpine.data('ageVerification', () => new AgeVerification(coc as VideoEdition));
